export const SET_ISLOGIN = "SET_ISLOGIN";
export const SET_REMEMBER_ME = "SET_REMEMBER_ME";
export const SET_PERSIST_USERNAME = "SET_PERSIST_USERNAME";
export const SET_PERSIST_PASSWORD = "SET_PERSIST_PASSWORD";
export const SET_DARK_THEME = "SET_DARK_THEME";
export const SET_CURRENT_USER_DATA = "SET_CURRENT_USER_DATA";
export const SET_ROW_STATUS = "SET_ROW_STATUS";
export const SET_IS_MODAL_OPEN = "SET_IS_MODAL_OPEN";
export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const SET_NAMING_PAGES = "SET_NAMING_PAGES";
export const SET_DEPARTMENTSDATA = "SET_DEPARTMENTS_DATA";
export const SET_USERS_DATA = "SET_USERS_DATA";
export const SET_ROLES_DATA = "SET_ROLE_DATA";
export const SET_GROUPING_DATA = "SET_GROUPING_DATA";
export const SET_ARTICLES_DATA = "SET_ARTICLES_DATA";
export const SET_NEWS_DATA = "SET_NEWS_DATA";
export const SET_PROJECTS_DATA = "SET_PROJECTS_DATA";
export const SET_FAQ_DATA = "SET_FAQ_DATA";
export const SET_TOKEN_NEEDED = "SET_TOKEN_NEEDED";

// Define the action creators with type annotations
export const isLogin = (data: boolean) => ({
    type: SET_ISLOGIN,
    payload: data,
});

export const setRememberMe = (data: boolean) => ({
    type: SET_REMEMBER_ME,
    payload: data,
});

export const setPersistUsername = (data: string) => ({
    type: SET_PERSIST_USERNAME,
    payload: data,
});

export const setPersistPassword = (data: string) => ({
    type: SET_PERSIST_PASSWORD,
    payload: data,
});

export const setTheme = (theme: string) => ({
    type: SET_DARK_THEME,
    payload: theme,
});

export const setCurrentUserData = (data: string) => ({
    type: SET_CURRENT_USER_DATA,
    payload: data,
});

export const setRowStatus = (id: string, status: boolean) => ({
    type: SET_ROW_STATUS,
    payload: { id, status },
});

export const setIsModalOpen = (isModalOpen: boolean) => ({
    type: SET_IS_MODAL_OPEN,
    payload: isModalOpen,
});

export const setModalData = (
    title: string,
    message: string,
    buttonText: string,
    confirmAction?: () => void,
    id?: string
) => ({
    type: SET_MODAL_DATA,
    payload: { title, message, buttonText, confirmAction, id },
});

export const setNamingPages = (data: any) => ({
    type: SET_NAMING_PAGES,
    payload: data,
});

export const setDepartmentsData = (data: any) => ({
    type: SET_DEPARTMENTSDATA,
    payload: data,
});

export const setUsersData = (data: any) => ({
    type: SET_USERS_DATA,
    payload: data,
});

export const setRolesData = (data: any) => ({
    type: SET_ROLES_DATA,
    payload: data,
});

export const setGroupingData = (data: any) => ({
    type: SET_GROUPING_DATA,
    payload: data,
});

export const setArticlesData = (data: any) => ({
    type: SET_ARTICLES_DATA,
    payload: data,
});

export const setNewsData = (data: any) => ({
    type: SET_NEWS_DATA,
    payload: data,
});

export const setProjectsData = (data: any) => ({
    type: SET_PROJECTS_DATA,
    payload: data,
});

export const setFaqData = (data: any) => ({
    type: SET_FAQ_DATA,
    payload: data,
});

export const setNewTokenNeeded = (data: any) => ({
    type: SET_TOKEN_NEEDED,
    payload: data,
});
